import { render } from "./PaymentTime.vue?vue&type=template&id=deaf65d4&ts=true"
import script from "./PaymentTime.vue?vue&type=script&lang=ts"
export * from "./PaymentTime.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__